var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "235.488px",
    height: "251.188px",
    viewBox: "0 0 235.488 251.188",
    enableBackground: "new 0 0 235.488 251.188",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BCC1C6",
    d: "M94.195,98.12c0,8.666-7.033,15.699-15.699,15.699l0,0c-8.666,0-15.699-7.033-15.699-15.699V74.571 c0-8.666,7.033-15.699,15.699-15.699l0,0c8.666,0,15.699,7.033,15.699,15.699V98.12z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BCC1C6",
    points: "235.488,164.284 224.483,153.067 215.864,161.844 215.864,58.872 200.165,58.872 200.165,161.844  191.546,153.067 180.541,164.284 197.01,181.051 196.963,181.099 207.968,192.315 208.015,192.269 208.062,192.315  219.066,181.099 219.02,181.051  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCC1C6",
    d: "M78.496,15.699c34.625,0,62.797,28.172,62.797,62.797v94.195c0,34.625-28.172,62.797-62.797,62.797 s-62.797-28.172-62.797-62.797V78.496C15.699,43.872,43.872,15.699,78.496,15.699 M78.496,0C35.143,0,0,35.143,0,78.496v94.195 c0,43.346,35.143,78.496,78.496,78.496c43.354,0,78.496-35.15,78.496-78.496V78.496C156.992,35.143,121.85,0,78.496,0L78.496,0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/Down Arrow.779749736663a102625eccc098ee938f.svg";
export { ForwardRef as ReactComponent };